import { render, staticRenderFns } from "./DataMapList.vue?vue&type=template&id=0b6efc8a"
import script from "./DataMapList.vue?vue&type=script&lang=js"
export * from "./DataMapList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b6efc8a')) {
      api.createRecord('0b6efc8a', component.options)
    } else {
      api.reload('0b6efc8a', component.options)
    }
    module.hot.accept("./DataMapList.vue?vue&type=template&id=0b6efc8a", function () {
      api.rerender('0b6efc8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/datav/DataMapList.vue"
export default component.exports